import React from "react";
import IChatbot from "../../../../interface/iChatbot";
import { AppContext } from "../../../../store/genesys.context";
import StyledPrimaryButton from "../styledPrimaryButton.styled";

const ToChatButton = (): React.JSX.Element => {
  const {
    chatbot,
    setRateChat,
    handleOpenChat,
  }: {
    chatbot: IChatbot;
    setRateChat: React.Dispatch<React.SetStateAction<boolean>>;
    handleOpenChat: (state: boolean) => void;
  } = React.useContext(AppContext);

  const getButtonText = (): string =>
    chatbot.messages.length > 1
      ? "Unterhaltung fortsetzen"
      : "Unterhaltung starten";

  const handleClick = (): void => {
    handleOpenChat(true);
    setRateChat(false);
  };

  return (
    <StyledPrimaryButton onClick={handleClick} fullWidth variant="contained">
      {getButtonText()}
    </StyledPrimaryButton>
  );
};

export default ToChatButton;
